import React, { useEffect, useState } from 'react';
import Topbar from '../../../components/Topbar';
import Leftbar from '../../../components/Leftsidebar';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import { allotSubscription, handleLenderlist, removeIdenfy, removeSubscription, showToast, usTimezone, formatReferralSource, VerifyIdenfy, changeRole, deleteUsers } from '../../Utils/utils';
import moment from 'moment-timezone';
import Loaderspinner from '../../../components/Loader';
import { handleExportLenderlist } from '../../Utils/utils';
import { Tooltip } from 'react-tooltip'
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';

const Lenderlist = () => {
  const [typeStatus, setTypeStatus] = useState("");
  const [activeStatus, setActiveStatus] = useState("");
  const [search, setSearch] = useState("");
  const [lenderList, setLenderList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState('')
  const [selectedIds, setSelectedIds] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);

  const limit = 10;

  const role = localStorage.getItem("role")

  useEffect(() => {
    if (search.length == 0 || search.length >= 3) {
      fetchLenders();
    }
  }, [typeStatus, activeStatus, page, search]);

  useEffect(() => {
    setSelectedIds([]);
  }, [lenderList]);

  const toggleSelectAll = (checked) => {
    setSelectedIds(checked ? lenderList.map((lender) => lender.id) : []);
  };

  const toggleSelectOne = (id, checked) => {
    setSelectedIds((prev) => (checked ? [...prev, id] : prev.filter((selectedId) => selectedId !== id)));
  };

  const confirmDeleteUsers = (ids) => {
    setDeleteIds(ids);
    setShowDelete(true);
  };

  const onDeleteUsers = async () => {
    try {
      setLoading(true);
      setShowDelete(false);
      await deleteUsers(deleteIds);
      showToast('User deleted successfully', "success");
      setSelectedIds([]);
      fetchLenders();
    } catch (error) {
      showToast(error?.message, "error");
      console.error("Error deleting users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLenders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const limit = 10;
      const offset = page * limit;

      const response = await handleLenderlist({
        type: typeStatus,
        active_status: activeStatus,
        limit,
        offset,
        token, search
      });
      setLenderList(response?.data?.rows);
      setTotalPages(response.data.count / limit)
    } catch (error) {
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false);
    }
  };

  const ExportList = async () => {
    try {
      setLoading(true);
      const blobData = await handleExportLenderlist({
        type: typeStatus,
        active_status: activeStatus,
      });

      if (blobData.size === 6506) {
        showToast("No data available for export.", "error");
        return;
      }

      const blob = new Blob([blobData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "lender_list.csv");
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const onAllotSubs = async (id) => {
    const res = await allotSubscription('LENDER', id)
    fetchLenders();
  }
  const onRemoveSubs = async (id) => {
    const res = await removeSubscription(id);
    fetchLenders();
  }


  const onVerifyIdenfy = async (id) => {
    const res = await VerifyIdenfy(id)
    fetchLenders();
  }
  const onRemoveIdenfy = async (id) => {
    const res = await removeIdenfy(id);
    fetchLenders();
  }

  const SwitchUser = async (id) => {
    try {
      setLoading(true);
      setShow(false);
      const token = localStorage.getItem("token");
      const response = await changeRole(id, 'raiser');
      if (response?.status == '200') {
        showToast('User role switched successfully', "success")
        fetchLenders()
      } else {
        showToast(response?.message, "error")
      }
    } catch (error) {
      showToast(error?.message, "error")
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <main className="border-radius-lg">
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0 d-flex flex-wrap justify-content-between align-items-center">
                      <div className='Table-title row'>
                        <h5 className="mb-0 w-auto">Lenders</h5>
                        <p
                          className="w-auto px-0"
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content="This report shows all registered lenders on the platform. Use it to verify lender details, track active participants, and monitor potential funding sources for borrower projects."
                          data-tooltip-place="right"
                        >
                          <i className="fas fa-info-circle" />

                        </p>

                        <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                      </div>
                      <div className="mt-3 mt-lg-0">
                        <input
                          type="text"
                          className="search-input mx-2"
                          placeholder="Search"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />

                        <select
                          className="custom-select-dropdown mx-2"
                          value={typeStatus}
                          onChange={(e) => setTypeStatus(e.target.value)}
                        >
                          <option value="" className='option'>Verified Status</option>
                          <option value="verified" className='option'>Verified</option>
                          <option value="unverified" className='option'>Unverified</option>
                        </select>

                        <select
                          className="custom-select-dropdown ml-3"
                          value={activeStatus}
                          onChange={(e) => setActiveStatus(e.target.value)}
                        >
                          <option value="" className='option'>Active Status</option>
                          <option value="active" className='option'>Active</option>
                          <option value="inactive" className='option'>Inactive</option>
                        </select>

                        <button
                          className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2'
                          onClick={ExportList}
                        >
                          <span>Export Lenders</span>
                        </button>

                        {role !== "virtual_assistant" && (
                          <button
                            className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2'
                            style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}
                            disabled={selectedIds.length === 0}
                            onClick={() => confirmDeleteUsers(selectedIds)}
                          >
                            <span>Delete Selected ({selectedIds.length})</span>
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            {role !== "virtual_assistant" && (
                              <th>
                                <input
                                  type="checkbox"
                                  checked={lenderList.length > 0 && selectedIds.length === lenderList.length}
                                  onChange={(e) => toggleSelectAll(e.target.checked)}
                                />
                              </th>
                            )}
                            <th>Action</th>
                            <th>Name</th>
                            <th>Username</th>
                            <th>Email</th>
                            <th>Phone number</th>
                            <th>Address</th>
                            <th>Created</th>
                            <th>Heard about us</th>
                            <th>Invest Type</th>
                            <th>Invest</th>
                            <th>Last login</th>
                            <th>Verification status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lenderList.length > 0 ? (
                            lenderList.map((lender, index) => (
                              <tr key={index}>
                                {role !== "virtual_assistant" && (
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedIds.includes(lender.id)}
                                      onChange={(e) => toggleSelectOne(lender.id, e.target.checked)}
                                    />
                                  </td>
                                )}
                                <td>
                                  <div style={{ width: "150px" }}>
                                    <Link to={`/view-user/${lender.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View User</span>
                                      </button>
                                    </Link>
                                    {role !== "virtual_assistant" &&
                                      <>
                                        {lender.about.subscription_status === 'subscribed' ?
                                          // <Link to={`/view-user/${lender.id}`} target="_blank">
                                          <button className="viewproject-btn-2 pull-right mb-1" onClick={() => onRemoveSubs(lender.id)}>
                                            <span className="text-white">Remove Subscription</span>
                                          </button>
                                          // </Link>
                                          :
                                          // <Link to={`/view-user/${lender.id}`} target="_blank">
                                          <button className="viewproject-btn pull-right mb-1" onClick={() => onAllotSubs(lender.id)}>
                                            <span className="text-white">Allot Subscription</span>
                                          </button>
                                          // </Link>
                                        }
                                        {(lender.about.idenfyStatus == null || lender.about.idenfyStatus == 'REJECTED') ?
                                          // <Link to={`/view-user/${lender.id}`} target="_blank">
                                          <button className="viewproject-btn pull-right mb-1" onClick={() => onVerifyIdenfy(lender.id)}>
                                            <span className="text-white">Verify Idenfy</span>
                                          </button>
                                          // </Link>
                                          :
                                          (lender.about.idenfyStatus == 'APPROVED') ?
                                            // <Link to={`/view-user/${lender.id}`} target="_blank">
                                            <button className="viewproject-btn-2 pull-right mb-1" onClick={() => onRemoveIdenfy(lender.id)}>
                                              <span className="text-white">Remove Idenfy</span>
                                            </button>
                                            : (lender.about.idenfyStatus == 'PENDING') ?
                                              <>
                                                <button className="viewproject-btn pull-right mb-1" onClick={() => onVerifyIdenfy(lender.id)}>
                                                  <span className="text-white">Verify Idenfy</span>
                                                </button>

                                                <button className="viewproject-btn-2 pull-right mb-1" onClick={() => onRemoveIdenfy(lender.id)}>
                                                  <span className="text-white">Remove Idenfy</span>
                                                </button>
                                              </>
                                              : null
                                          // </Link>
                                        }
                                      </>
                                    }
                                    <button className="viewproject-btn-2 pull-right mb-1" onClick={() => { setShow(true); setUserId(lender.id) }}>
                                      <span className="text-white">Switch to borrower</span>
                                    </button>
                                  </div>
                                </td>
                                <td><div style={{ width: "120px" }}>{lender?.about?.name} {lender?.about?.lastname}</div></td>
                                <td><div style={{ width: "120px" }}>{lender?.about?.username}</div></td>
                                <td><div style={{ width: "120px" }}>{lender.email}</div></td>
                                <td><span>{lender.phone}</span></td>
                                <td><div style={{ width: "120px" }}>{lender?.about?.address}</div></td>
                                <td><div style={{ width: "120px" }}>{lender?.created ? usTimezone(lender.created) : ' '}</div></td>
                                <td><div style={{ width: "140px" }}>{formatReferralSource(lender?.about)}</div></td>
                                <td><div style={{ width: "120px" }}>{lender?.about?.invest_type?.join(", ")}</div></td>
                                <td><div style={{ width: "120px" }}>{lender?.about?.invest}</div></td>
                                <td><div style={{ width: "120px" }}>{lender?.lastlogin ? usTimezone(lender.lastlogin) : ' '}</div></td>
                                <td>
                                  {lender?.about?.idenfyStatus === "PENDING" && (
                                    <div style={{ width: "120px" }} className="p-1 pendingstatus"><span>Pending</span></div>
                                  )}
                                  {lender?.about?.idenfyStatus === "REJECTED" && (
                                    <div style={{ width: "120px" }} className="p-1 unverifiedstatus"><span>Rejected</span></div>
                                  )}
                                  {lender?.about?.idenfyStatus === "APPROVED" && (
                                    <div style={{ width: "120px" }} className="p-1 verifiedstatus"><span>Approve</span></div>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="14" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>


                  {lenderList.length > 0 && (
                    <Row>
                      <Col xs={12}>
                        <div className='paginate-css'>
                          <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel="..."
                            pageCount={totalPages}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={({ selected }) => setPage(selected)}
                            forcePage={page}
                            containerClassName="pagination"
                            activeClassName="active"
                            previousClassName={page === 0 ? 'disabled' : ''}
                            nextClassName={page >= totalPages - 1 ? 'disabled' : ''}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}




                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ConfirmationModal
        show={show}
        onClose={() => setShow(false)}
        onConfirm={() => SwitchUser(userId)}
        title="Change Role"
        body="Are you sure you want to switch this user role from lender to borrower?"
      />
      <ConfirmationModal
        show={showDelete}
        onClose={() => setShowDelete(false)}
        onConfirm={onDeleteUsers}
        title="Delete User"
        body={`Are you sure you want to delete ${deleteIds.length > 1 ? `these ${deleteIds.length} users` : 'this user'}? This action cannot be undone.`}
        confirmText="Delete"
      />
    </>
  );
};

export default Lenderlist;
